import { defineStore } from 'pinia'
import { ref } from 'vue'
import { UsersService, type SuperUserUser as User, type SuperUserUser } from '@/types/generated'

export const useUserStore = defineStore('user', () => {
  const user = ref<User | undefined>(undefined)

  async function fetchUser() {
    user.value = (await UsersService.usersRetrieve({ uuid: 'current' })) as SuperUserUser
  }

  return { user, fetchUser }
})
